module.exports = __webpack_public_path__ + "img/gld_gbt839_1988.prt.29f2c2bb.jpg";